import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus, ArrowRight } from 'lucide-react';
const advantages = [{
  id: '01',
  title: 'Manufacturer-level after-sales',
  description: 'Our in-house engineers fix issues with proprietary hardware and training — no 4-6 week waits for manufacturer callouts that rivals depend on.'
}, {
  id: '02',
  title: 'Quality installs that last',
  description: 'Our installations consistently deliver 16-year lifespans. We never cut corners on materials or workmanship, saving you money long-term.'
}, {
  id: '03',
  title: 'Detailed service reports',
  description: 'Every visit includes comprehensive photo documentation — before and after. Reports that wow clients and make contract renewals effortless.'
}, {
  id: '04',
  title: 'Above-standard accreditations',
  description: 'Constructionline Gold (held by just 1-2% of firms), CHAS, SafeContractor, REFCOM, F-Gas certified. We go well beyond the industry baseline.'
}, {
  id: '05',
  title: 'TM44 compliance experts',
  description: 'Branded in-house TM44 inspections linked to ISO14001. Required every 5 years for systems over 12kW — we handle it all.'
}];
export function Advantages() {
  const [openId, setOpenId] = useState<string | null>('01');
  return <section id="why-us" className="py-24 bg-primary-light" data-id="element-51">
      <div className="container mx-auto px-6" data-id="element-52">
        <div className="grid lg:grid-cols-2 gap-16 items-start" data-id="element-53">
          <div data-id="element-54">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-5xl mb-12 max-w-md" data-id="element-55">
              Why choose AccuTemp
            </motion.h2>

            <div className="space-y-2" data-id="element-56">
              {advantages.map(adv => <div key={adv.id} className="border-b border-primary-dark/10 last:border-0" data-id="element-57">
                  <button onClick={() => setOpenId(openId === adv.id ? null : adv.id)} className="w-full py-6 flex items-center justify-between text-left group" data-id="element-58">
                    <div className="flex items-center gap-6" data-id="element-59">
                      <span className="text-sm text-primary-dark/40 font-medium" data-id="element-60">
                        {adv.id}
                      </span>
                      <span className={`text-lg font-medium transition-colors ${openId === adv.id ? 'text-primary-dark' : 'text-primary-dark/70 group-hover:text-primary-dark'}`} data-id="element-61">
                        {adv.title}
                      </span>
                    </div>
                    <img src="https://cdn.magicpatterns.com/uploads/oA3faeBPf8gtucGgHUC7kH/arrow-down-navy.svg" alt="" className={`w-5 h-5 transition-transform duration-300 ${openId === adv.id ? 'rotate-180' : ''}`} data-id="element-62" />
                  </button>
                  <AnimatePresence data-id="element-63">
                    {openId === adv.id && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} className="overflow-hidden" data-id="element-64">
                        <p className="pb-6 pl-12 text-primary-dark/70 text-sm leading-relaxed max-w-md" data-id="element-65">
                          {adv.description}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>)}
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative h-[600px] rounded-2xl overflow-hidden" data-id="element-66">
            <img src="https://cdn.magicpatterns.com/uploads/1vvMrb2b8JH4wTbAc6JD1S/UATYA-BRS4_Installation_picture_002.png" alt="Commercial HVAC installation by AccuTemp" className="w-full h-full object-cover" data-id="element-67" />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-dark/80 via-transparent to-transparent" data-id="element-68"></div>

            <div className="absolute bottom-8 left-8 right-8 flex justify-end" data-id="element-69">
              <button className="group flex items-center gap-4 bg-accent hover:bg-accent/90 text-white px-6 py-3 rounded-full transition-all duration-300 backdrop-blur-sm" data-id="element-70">
                <span className="font-medium text-sm" data-id="element-71">
                  Request a free quote
                </span>
                <img src="https://cdn.magicpatterns.com/uploads/bPzFdwHywdHpFHfUSsV2QY/arrow-right-circle-white.svg" alt="" className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-72" />
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}